import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import SalesOrderInfoTable from '../detail/SalesOrderInfoTable'
import SalesOrderPriceTable from '../detail/SalesOrderPriceTable'
import SalesOrderPaymentDetails from '../detail/SalesOrderPaymentDetails'
import LabelInput from '../../../form/component/LabelInput'
import TextArea from '../../../form/component/TextArea'
import currentUserHasAccess from '../../../../util/widget-helper'
import { SALES_ORDER_OVERVIEW } from '../../ui-definition/sales-order-ui'

const TITLE = {
    'set': 'Set',
    'treatment': 'Treatment',
    'treatment-new': 'Treatment New',
    'shop-scan': 'Shop Scan',
    'shop-scan-new': 'Shop Scan New',
    'retainer': 'Retainer',
    'retainer-new': 'Retainer New',
    'refinement-set': 'Refinement (Set)',
    'refinement-shop': 'Refinement (Shop)',
    'refinement-shop-new': 'Refinement (Shop New)',
    'refinement-production': 'Refinement Production',
    'in-shop-scan': 'Clinic 3D-Scan',
    'in-shop-scan-new': 'Clinic 3D-Scan New',
    'escalation': 'Escalation',
    'check-in': 'Clinic Check-In',
    'check-in-New': 'Clinic Check-In New',
    'aligner-reproduction': 'Aligner Reproduction',
    'implant-3d-scan': 'Implant Clinic 3D-Scan',
    'implant-plan': 'Implant Plan',
    'implant-treatment': 'Implant Treatment',
    'retainer-refinement': 'Retainer Refinement',
    'retainer-refinement-new': 'Retainer Refinement New',
    'partial-refund': 'Partial Refund',
}

const SalesOrderComment = ({ salesOrder, changeSalesOrder, saveSalesOrder }) => {
    if (salesOrder.hasProcess) {
        return null
    }
    return (
        <Row top="M">
            <Column size={12}>
                <LabelInput label="Comment">
                    <TextArea
                        name="comment"
                        object={salesOrder}
                        onChange={changeSalesOrder}
                        onBlur={saveSalesOrder}
                    />
                </LabelInput>
            </Column>
        </Row>
    )
}


const SalesOrderOverview = (props) => {
    if (!currentUserHasAccess(SALES_ORDER_OVERVIEW)) {
        return null
    }

    const { salesOrder } = props
    const customer = salesOrder.customer
    const title = TITLE[salesOrder.type] + ' ' + customer.firstName + ' ' + customer.lastName

    return (
        <ContentBox title={title}>
            <Row>
                <Column size={4}>
                    <SalesOrderInfoTable {...props}/>
                </Column>
                <Column size={4}>
                    <SalesOrderPaymentDetails salesOrder={salesOrder}/>
                </Column>
                <Column size={4}>
                    <SalesOrderPriceTable salesOrder={salesOrder}/>
                </Column>
            </Row>
            <SalesOrderComment {...props}/>
        </ContentBox>
    )
}

SalesOrderOverview.propTypes = {
    salesOrder: PropTypes.object.isRequired,
}

export default SalesOrderOverview



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/detail/SalesOrderOverview.js